import { GetItemChangesState } from './getItemChanges.types'

const initialState: GetItemChangesState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
